import { graphql } from "~/gql";

export const UPDATE_TECHNOLOGY_UNITS = graphql(/* GraphQL */ `
  mutation UpdateTechnologyUnits($data: [UpdateTechnologyUnitInput!]!) {
    updateTechnologyUnits(data: $data) {
      ...TechnologyUnitParts
    }
  }
`);
